import React, { Component } from "react";

class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <li>
                        <img src="/assets/images/brand/mysql-logo-4.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/jquery-logo-2.webp" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/oracle-logo-1.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/wordpress-logo-1.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/nodejs-logo-1.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/react-logo-1.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/json-logo-1.png" alt="Logo Images"/>
                    </li>
                    {/* <li>
                        <img src="/assets/images/brand/brand-03.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/brand-04.png" alt="Logo Images"/>
                    </li> */}
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;